import React from "react";
import CustomTextField from "../CustomTextField";

const StandaloneFieldInput = ({
  fieldName,
  fieldConfig,
  handleChange,
  editInfo,
  errorInfo,
}) => (
  <CustomTextField
    id={fieldName}
    handleChange={handleChange(fieldName)}
    value={editInfo[fieldName]}
    error={errorInfo[fieldName]}
    label={fieldConfig.label}
    inputProps={{ min: fieldConfig.minValue, max: fieldConfig.maxValue }}
    type={fieldConfig.type}
  />
);

export default StandaloneFieldInput;
